import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationES from "./locales/es/translation.json";
import translationPT from "./locales/pt/translation.json";
import { LanguageDetectorModule } from "i18next";
import { idiomaInicial } from "./lib/idioma";

export const supportedLanguages = ["pt", "es"] as const;

export type Language = (typeof supportedLanguages)[number];

// Não guarda o idioma a cada troca (o antigo "i18nextLng" prendia quem já tinha sido
// redirecionado para /pt). A escolha manual é guardada à parte, em lib/idioma.
const customLangDetector: LanguageDetectorModule = {
  type: "languageDetector",
  detect: (): string => idiomaInicial(),
  init: () => {},
  cacheUserLanguage: () => {},
};

i18n
  .use(customLangDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "pt",
    supportedLngs: supportedLanguages,
    resources: {
      pt: { translation: translationPT },
      es: { translation: translationES },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
